module.exports = __webpack_public_path__ + "static/media/applogo.e6d5b37b.png";